<template>
  <main-content with_go_back_bar>
    <kt-panel>
        <form @submit.prevent="submit($event, query)"
              id="single-request-form"
              class="kt-form p-3 my-4"
        >
            <div class="container p-3 pt-5 my-4 border in-border-header" style="padding-top: 1.5rem !important;">
                <kt-form-section is_first>
                    <div class="section-header">
                      {{ $t('online-factor.info_item') }}
                    </div>
                    <kt-row class="p-2">
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="title">
                                    {{ $t('online-factor.title_item') }}
                                    <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-control id="title" name="title" v-model="detailItem.title">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="item_code">
                                    {{ $t('online-factor.item_code') }}
                                </kt-form-label>
                                <kt-form-control id="item_code" name="item_code" v-model="detailItem.item_code">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12" v-if="detailItem.description !== 'undefined'">
                            <kt-form-group>
                                <kt-form-label for="description">
                                    {{ $t('online-factor.description') }}
                                </kt-form-label>
                                <kt-form-control id="description" name="description" v-model="detailItem.description">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="amount">
                                    {{ $t('online-factor.amount') }}
                                    <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-control id="amount" name="amount" v-model="detailItem.amount">
                                </kt-form-control>
                                <span style="font-size:1rem;color:#00bea5" v-if="detailItem.amount">
                                       {{ currencyFormat(detailItem.amount) + ' ' + $t('currency.toman') }}
                                 </span>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="quantity">
                                    {{ $t('online-factor.quantity') }}
                                    <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-control id="quantity" name="quantity" v-model="detailItem.quantity"
                                :disabled="detailItem.is_unlimited == 1">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="file">
                                    <kt-icon type="fa" name="paperclip"></kt-icon>
                                    {{ $t('online-factor.image') }}
                                </kt-form-label>
                                <kt-form-control
                                    @change="processFile"
                                    type="file"
                                    class="custom-file-upload"
                                    name="file"
                                    id="file"
                                    accept=".jpg"/>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12" class="py-2">
                            <kt-form-group class="my-2">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox"
                                           class="custom-control-input"
                                           id="is_unlimited"
                                           name="is_unlimited"
                                           v-model="detailItem.is_unlimited"
                                    >
                                    <label class="custom-control-label" for="is_unlimited">
                                        {{ $t('online-factor.is_unlimited') }}
                                    </label>
                                </div>
                            </kt-form-group>
                            <kt-form-group class="my-2">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox"
                                           class="custom-control-input"
                                           id="has_tax"
                                           name="has_tax"
                                           v-model="detailItem.has_tax"
                                    >
                                    <label class="custom-control-label" for="has_tax">
                                        {{ $t('online-factor.has_tax') }}
                                    </label>
                                </div>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <img v-if="detailItem.image !== null" id="logo_preview"  class="preview_img"/>
                              <img src="../../assets/media/item.png" alt="" class="preview_img" v-else>
                        <!-- <i @click="removeImage()" class="fa fa-trash btnRemoveImage"></i>
                        <span class="removeImageTitle"> حذف عکس</span> -->
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-button
                                id="form-btn"
                                class="btn btn-success btn-wide text-center py-2 mt-2"
                                type="submit"
                                variant="success"
                                @click="submit()"
                            >
                              {{ $t('online-factor.edit_item') }}
                            </kt-button>
                        </kt-col>
                    </kt-row>
                </kt-form-section>
            </div>
        </form>
    </kt-panel>
  </main-content>
</template>

<script>

import $ from "jquery";
import toastr from 'toastr';
import { KTApp } from '@/plugins/core/app'
import {mapGetters} from "vuex";
import mainContent from '@/components/main-content'
import { onlineFactorService } from '@/common/api.service';



export default {
  components: {
    'main-content': mainContent,
  },
    props: {
        submitSingleRequest: {
            default: function($event, query) {},
            type: Function
        },
    },
    data() {
        return {
            query: {
                is_unlimited: false,
            },
            hashid: this.$route.params.hashid,
            picPreview: "",
            newImage: null
        }
    },
    computed : {
      ...mapGetters('onlineFactor', [
        'detailItem'
      ]),
      toastr() {
        toastr.options = {
          closeButton: true,
          positionClass: "toast-bottom-center",
          preventDuplicates: false,
          rtl: false
        }
        return toastr
      },
    },
    methods: {
      submitRequest(e,query){
        console.log(e,query);
      },
      submit(e, query) {
        let form = $('#single-request-form')
        let btn = $('#form-btn')

        

        form.validate({
          rules: {
            title: {
              required: true
            },
            amount: {
              required: true,
            },
            item_code: {
              required: false,
            },
            description: {
              required: false,
              maxlength: 200,
            },
            quantity: {
              required: true,
            },
            image: {
              required: true
            }
          }
        })

        if (!form.valid())
          return;

        KTApp.progress(btn)
        let formData = new FormData();
        formData.append('title',this.detailItem.title)
        formData.append('item_code',this.detailItem.item_code ? this.detailItem.item_code : "")
        formData.append('amount',this.detailItem.amount)
        formData.append('description',this.detailItem.description ? this.detailItem.description : "")
        formData.append('is_unlimited',this.detailItem.is_unlimited)
        formData.append('quantity',this.detailItem.quantity)
        formData.append('has_tax',this.detailItem.has_tax)
        if(typeof(this.detailItem.image) === 'string' || this.detailItem.image === null){
            formData.append('image','')
        }else{
            formData.append('image',this.detailItem.image)
        }
        onlineFactorService.updateItem(this.hashid,formData).then(response=>{
            if(response.status === 200){
                this.$router.push('/items')
            }
        }).catch(({response}) => {
            this.toastr.error(response.data.message)
            for(let err in response.data.data){
                this.toastr.error(response.data.data[err][0])
            }
        }).finally(()=>{
          KTApp.unprogress(btn)
        })
      },
        currencyFormat(price) {
            price = Math.floor(price / 10);
            const pieces = parseFloat(price).toFixed(0).split('');
            let ii = pieces.length;

            while ((ii -= 3) > 0) {
                pieces.splice(ii, 0, ',');
            }

            return pieces.join('');
        },
        processFile(e) {
            this.detailItem.image = e.target.files[0]
            let output = document.getElementById('logo_preview');
            output.src = URL.createObjectURL(e.target.files[0]);
            output.onload = function() {
                URL.revokeObjectURL(output.src) // free memory
            }
        },
    },
    mounted() {
      let is_admin = this.$can('read', 'payment-link');
      let action = is_admin ? 'onlineFactor/adminShowItem' : 'onlineFactor/showItem';
      this.$store.dispatch(action, this.$route.params.hashid).then(response => {
        let output = document.getElementById('logo_preview');
          output.src = this.detailItem.image;
          output.onload = function() {
            URL.revokeObjectURL(output.src) // free memory
          },
          error => {
            
            }
        }
      )
    },
    watch: {
        'query.is_unlimited'(value) {
            if (value) {
                this.query.quantity = "";
            }
        }
    }
}
</script>
<style scoped>

.preview_img {
    max-width: 70px;
    max-height: 70px;
    position: absolute;
    top: 10px;
    left: 80px;
}

.removeImageTitle{
  font-size: 10px;
}

.btnRemoveImage{
  cursor: pointer;
}
</style>